var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBankCardFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bank-card-fill"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M36.6752 16.6667V33.3333C36.6752 34.2538 35.929 35 35.0085 35H5.00846C4.088 35 3.3418 34.2538 3.3418 33.3333V16.6667H36.6752ZM36.6752 13.3333H3.3418V6.66667C3.3418 5.7462 4.088 5 5.00846 5H35.0085C35.929 5 36.6752 5.7462 36.6752 6.66667V13.3333ZM25.0085 26.6667V30H31.6752V26.6667H25.0085Z",
    fill: "#006B5D"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBankCardFill);
export default __webpack_public_path__ + "static/media/bank-card-fill.dd7ffa93935a4c3df1920c9587a38622.svg";
export { ForwardRef as ReactComponent };